import { Injectable } from "@angular/core";
import { IReferrer } from "../../model";

@Injectable({
  "providedIn": "root",
})
export class ReferralService {
  referrers: IReferrer[] = [
    {
      "name": "Gross Fuchs",
      "code": "GrssFchs",
      "logoUrl": "/static/registration-logos/gross-fuchs.jpg",
    },
    {
      "name": undefined,
      "code": "TrksCrgo",
      "logoUrl": "/static/registration-logos/turkish-cargo.jpg",
    },
  ];

  getReferrerFromReferralCode (code: string): IReferrer {
    // TODO: Retrieve and validate from a proper data source
    return this.referrers.find((referrer) => referrer.code === code);
  }
}
